import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { taskUnassign, requestTasks } from "../../redux/task/taskActions";
import { requestAssignTask } from "../../redux/assignment/assignmentActions";
import AssignTaskModal from "./assignTaskModal";
import moment from "moment";

/*
    controls to display a modal form used to assign a resource to a
    work order.  Once the resource has been assigned it will display any
    overlaps returned from the server API call

    props:
        - workOrder: {
            workOrderID, 
            workOrderNumber,
            duration
        }
        - show: () => void
        overlaps: array of overlap to display to the user
        technicians: array of resource to select from
        assignTask: (assignment, overrideOverlap: bool) => void
            callback used to assign the task
        clearAssignmentOverlaps: () => void
            callback used to clear any current overlaps
*/

export const AssignTask = (props) => {
    const { workOrder = {}, isUnassigned } = props;
    const acceptAssignment = (technician, start) => {
        const assignment = {
            workOrderNumber: workOrder.workOrderNumber,
            resourceAssignedTo: technician.id,
            //taskAssignedDate: start,
            scheduledDate: start ? moment(moment(start)).utc().format("YYYY-MM-DD HH:mm:ss") : "",
            duration: workOrder.duration,
        };

        props.requestAssignTask(workOrder, technician, assignment, false, isUnassigned);

        // close modals
        props.close();
    };
    const onHandleUnassign = (technician, start) => {
        const assignment = {
            workOrderNumber: workOrder.workOrderNumber,
            resourceAssignedTo: null,
            //taskAssignedDate: start,
            scheduledDate: start,
            duration: workOrder.duration,
        };
        props.taskUnassign(workOrder.workOrderNumber);
        props.workOrderNumber
            ? props.requestTasks({ fetchCounts: true, workOrderNumber: workOrder?.workOrderNumber })
            : props.requestTasks({ fetchCounts: true, workOrderNumber: "" });
        //props.requestAssignTask(workOrder, technician, assignment, false, true)
    };

    return (
        <React.Fragment>
            <AssignTaskModal
                id="assign-task-modal"
                show={props.show}
                technicians={props.technicians}
                workOrder={workOrder}
                timeRange={props.timeRange}
                onAccept={acceptAssignment}
                onCancel={() => props?.close()}
                onHandleUnassign={onHandleUnassign}
            />
        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    technicians: state.technicians,
    overlaps: state.assignments.overlaps,
    timeRange: state.domain.timeRange,
    workOrderNumber: state.dashboard.workOrderNumber,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            requestAssignTask,
            taskUnassign,
            requestTasks,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(AssignTask);
